import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

const TerminationConfirmDialog = ({ open, onClose, onUpdate, confirming }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle variant='h4'>Επιβεβαίωση</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Είστε σίγουρος ότι θέλετε να προχωρήσετε στην ενημέρωση;
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Άκυρο</Button>
        <Button disabled={confirming} variant="contained" color="primary" onClick={onUpdate}
          startIcon={confirming ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {confirming ? "Ενημέρωση..." : "Επιβεβαίωση"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TerminationConfirmDialog;
